"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a CHANGE_AUTHORISATION_ROLES request.
 */
var ChangeAuthorisationRolesRequest = /** @class */ (function () {
    /**
     * Create a new ChangeAuthorisationRolesRequest instance
     *
     * @param sessionID         the session ID
     * @param rolesToRemove     the roles to remove
     * @param removeProperties  the roles to add
     */
    function ChangeAuthorisationRolesRequest(sessionID, rolesToRemove, rolesToAdd) {
        this.sessionID = sessionID;
        this.rolesToRemove = rolesToRemove;
        this.rolesToAdd = rolesToAdd;
    }
    return ChangeAuthorisationRolesRequest;
}());
exports.ChangeAuthorisationRolesRequest = ChangeAuthorisationRolesRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/change-authorisation-roles-request.js
// module id = 1243
// module chunks = 1